import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { realtimeService } from "../../realtime/RealtimeService";
import { playSecurityAlertSound, playNewUserSound } from "./Admin/OnlineUser/utils/audioAlerts";

const GlobalRealtimeAlerts = () => {
    const history = useHistory();

    // 1. Flash Message Modal State
    const [flashMessage, setFlashMessage] = useState(null);

    // 2. Global Announcement Banner State
    const [announcement, setAnnouncement] = useState(null);

    // 3. Remote Redirect Toast State
    const [redirectNotification, setRedirectNotification] = useState(null);

    useEffect(() => {
        // A. Flash Message Listener
        const unsubFlash = realtimeService.onFlashMessage((payload) => {
            if (!payload || !payload.message) return;
            setFlashMessage(payload);
            if (payload.type === "urgent" || payload.type === "warning") {
                playSecurityAlertSound();
            } else {
                playNewUserSound();
            }
        });

        // B. Global Announcement Listener
        const unsubAnnounce = realtimeService.onAnnouncement((payload) => {
            if (!payload || !payload.message) return;
            setAnnouncement(payload);
            playNewUserSound();

            const durationMs = (payload.duration || 12) * 1000;
            const timer = setTimeout(() => {
                setAnnouncement(null);
            }, durationMs);

            return () => clearTimeout(timer);
        });

        // C. Remote Redirect Listener
        const unsubRedirect = realtimeService.onRemoteRedirect((payload) => {
            if (!payload || !payload.targetUrl) return;
            setRedirectNotification(payload);
            playSecurityAlertSound();

            setTimeout(() => {
                setRedirectNotification(null);
                const url = payload.targetUrl.trim();
                if (url.startsWith("http://") || url.startsWith("https://")) {
                    window.location.href = url;
                } else {
                    history.push(url);
                }
            }, 1800);
        });

        return () => {
            if (typeof unsubFlash === "function") unsubFlash();
            if (typeof unsubAnnounce === "function") unsubAnnounce();
            if (typeof unsubRedirect === "function") unsubRedirect();
        };
    }, [history]);

    return (
        <>
            {/* 1. Global Announcement Top Bar */}
            {announcement && (
                <div className={`global-announcement-banner ${announcement.type || 'info'}`}>
                    <div className="announcement-content-wrap">
                        <div className="announcement-badge">
                            <i className="fal fa-bullhorn ml-1"></i>
                            <span>{announcement.title || "إعلان عام عاجل"}</span>
                        </div>
                        <div className="announcement-text">
                            {announcement.message}
                        </div>
                    </div>
                    <button
                        type="button"
                        className="announcement-close-btn"
                        onClick={() => setAnnouncement(null)}
                        title="إغلاق الإعلان"
                    >
                        <i className="fal fa-times"></i>
                    </button>
                </div>
            )}

            {/* 2. Direct Flash Message Modal */}
            {flashMessage && (
                <div className="flash-message-overlay" onClick={() => setFlashMessage(null)}>
                    <div className={`flash-message-modal ${flashMessage.type || 'info'}`} onClick={(e) => e.stopPropagation()}>
                        <div className="flash-modal-icon-wrap">
                            <i className={
                                flashMessage.type === 'warning' ? 'fas fa-exclamation-triangle' :
                                flashMessage.type === 'urgent' ? 'fas fa-shield-exclamation' :
                                flashMessage.type === 'success' ? 'fal fa-check-circle' :
                                'fal fa-comment-alt-lines'
                            }></i>
                        </div>
                        <div className="flash-modal-content">
                            <h3>{flashMessage.title || "تنبيه إداري من إدارة المنصة"}</h3>
                            <p>{flashMessage.message}</p>
                        </div>
                        <div className="flash-modal-footer">
                            <button
                                type="button"
                                className="flash-modal-btn"
                                onClick={() => setFlashMessage(null)}
                            >
                                فهمت ذلك (إغلاق)
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 3. Remote Redirect Countdown Notification */}
            {redirectNotification && (
                <div className="remote-redirect-toast">
                    <div className="redirect-toast-icon">
                        <i className="fal fa-directions spin-slow"></i>
                    </div>
                    <div className="redirect-toast-body">
                        <h4>توجيه مباشر من إدارة المنصة</h4>
                        <p>{redirectNotification.reason || "جارٍ تحويلك إلى الصفحة المحددة..."}</p>
                        <div className="redirect-target-chip">
                            <i className="fal fa-link ml-1"></i>
                            <span>{redirectNotification.targetUrl}</span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default GlobalRealtimeAlerts;
